import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ILocalization } from 'bernie-l10n';

import { UitkButtonSize, UitkPrimaryFloatingButton } from 'uitk-react-button';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';

const UitkPrimaryFloatingButtonTracked = ClickTracker(UitkPrimaryFloatingButton);

export interface HoldingAreaActionsProps {
  goToCheckout: () => void;
  l10n: ILocalization;
  isAllSoldOut: () => boolean;
  isNotFullCart: boolean;
}

export const HoldingAreaActions = ({ goToCheckout, l10n, isAllSoldOut, isNotFullCart }: HoldingAreaActionsProps) => (
  <UitkScrim type={UitkScrimType.BUTTON}>
    <UitkPrimaryFloatingButtonTracked
      className="uitk-cell"
      disabled={isAllSoldOut() || isNotFullCart}
      size={UitkButtonSize.LARGE}
      text={l10n.formatText('multiProperty.playback.continueToCheckout')}
      onClick={goToCheckout}
      rfrr="MultiProp.Checkout"
      linkName="MultiProp Checkout"
    />
  </UitkScrim>
);
